import { find } from "lodash";

export const getPatientPresetFilterFromReferralPatientInformation = referralPatientInformation => {
  if (!referralPatientInformation) return {};

  const { patientCards } = referralPatientInformation;
  return {
    givenName: referralPatientInformation.givenName,
    middleName: referralPatientInformation.middleName,
    familyName: referralPatientInformation.familyName,
    dateOfBirth: referralPatientInformation.birthDate,
    sex: referralPatientInformation.sex,
    dvaNumber: find(patientCards, x => x.patientCardTypeCode === "DVA")?.patientCard,
    medicareNumber: find(patientCards, x => x.patientCardTypeCode === "MC")?.patientCard,
  };
};
